// types
import type { MarkerOptions } from './showroom.types';
import type { ThemeNameProps } from 'themes/theme.types';

// utils
import { THEME_NAMES } from 'themes/theme.types';
import { isEmpty } from 'utils/is-empty';

const svgPin = (color: string) =>
  window.btoa(`
    <svg width="31" height="40" viewBox="0 0 31 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.992676 15C0.992676 6.75 7.74268 0 15.9927 0C24.2427 0 30.9927 6.75 30.9927 15C30.9927 18.25 29.7427 21.5 27.9927 24L15.9927 40L3.99268 24C2.24268 21.5 0.992676 18.25 0.992676 15ZM15.9927 7.5C11.7427 7.5 8.49268 10.75 8.49268 15C8.49268 19.25 11.7427 22.5 15.9927 22.5C20.2427 22.5 23.4927 19.25 23.4927 15C23.4927 10.75 20.2427 7.5 15.9927 7.5Z" fill="${color}"/>
    </svg>
`);

const svgHotel = (color: string) =>
  window.btoa(`
  <svg  viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <path d="m46.174 5.882c-3.735-3.752-8.783-5.866-14.05-5.882-5.337.04-10.456 2.145-14.303 5.882-3.738 3.81-5.831 8.96-5.821 14.324 0 5.628 3.543 12.406 6.708 18.416.887 1.79 1.9 3.58 2.533 5.119l9.24 19.312c.185.317.446.581.76.768.766.402 1.709.1 2.107-.674.016-.031.031-.062.045-.094l9.24-19.312c.76-1.534 1.772-3.199 2.658-5.119 3.166-5.882 6.708-12.788 6.708-18.416.066-5.376-2.037-10.548-5.825-14.324z" fill="${color}"/><path d="m45.362 15.388v12.744h-2.131v-4.443h-22.462v4.443h-2.067v-17.093h2.067v9.164h22.462v-4.815zm-20.974 3.571c1.345 0 2.435-1.102 2.435-2.461s-1.09-2.461-2.435-2.461-2.435 1.102-2.435 2.461 1.09 2.461 2.435 2.461zm16.619-.206v-1.29s-.02-1.29-1.107-1.29-8.781 0-9.887 0-2.004 1.29-2.004 1.29l-.807 1.29z" fill="#fff"/>
  </svg>
`);

const defaultThemeColor: Record<keyof typeof THEME_NAMES, string> = {
  NORD: '#26513B',
  DEFAULT: '#26513B',
  KOLO: '#1E818A',
  TWYFORD: '#245C4E',
  XY: '#376EB4',
  GDDS: '#26513B',
};

function getColor(
  categoryName: string,
  mode: string,
  categories: MarkerOptions['categories'],
  themeName: ThemeNameProps,
): string {
  let color = defaultThemeColor[themeName];
  if (mode !== 'event' && !isEmpty(categoryName)) {
    const maybeCategorie = categories.find((category) => category.categoryName === categoryName);

    if (maybeCategorie) {
      color = maybeCategorie.color;
    }
  }

  return color;
}

function buildIcon(maps: typeof window.google.maps, iconSize: number, color: string, mode: string) {
  const url = `data:image/svg+xml;base64,${mode === 'hotel' ? svgHotel(color) : svgPin(color)}`;
  const icon = {
    scaledSize: new maps.Size(iconSize, iconSize),
    origin: new maps.Point(0, 0),
    url,
  };

  return icon;
}

export function markerBuilder({
  maps,
  category: categoryName,
  categories,
  draggable,
  lat,
  lng,
  mode,
  themeName,
}: MarkerOptions): google.maps.Marker {
  const iconSize = mode === 'hotel' ? 48 : 40;
  const color = getColor(categoryName, mode, categories, themeName);
  const icon = buildIcon(maps, iconSize, color, mode);
  const position = new maps.LatLng(lat, lng);
  const marker = {
    position,
    draggable,
    icon,
  };

  return new maps.Marker(marker);
}
